'use strict';

import Loader from '../loader/loader';
import { toaster } from '../../_assets/abbott/js/_material';
import { isFieldEmpty, displayErrors } from '../../_assets/abbott/js/_helper';

let $body = $('body'),
    $updateDetailsDropdown = $('.update-account__dropdown'),
    $inputs = $('.update-account__dropdown input').not('#AdminEmailAddress'),
    $updateDetailsBtns = $('.update-details--admin__btn-wrappers'),
    $dropdowns = $('.update-account__dropdown select'),
    $errorContainer = $('.server-errors__wrap--admin-update');
    
let $firstName = $updateDetailsDropdown.find('input[name=FirstName]'),
    $lastName = $updateDetailsDropdown.find('input[name=LastName]'),
    $company = $updateDetailsDropdown.find('select[name=InstitutionId]'),
    $email = $updateDetailsDropdown.find('select[name=EmailAddress]'),
    $primaryNumber = $updateDetailsDropdown.find('select[name=MobileNumber]'),
    $abbottAdminId = $('#StaffShopUserId'),
    loader = new Loader(),
    dataParams = {},
    _isInvalid = [];

export default class StaffShopUpdateAccount {
    constructor() {

        //Make form editable
        $('.js-update-account').on('click', function (e){
            e.preventDefault();

            $(this).parent().hide();
            $updateDetailsBtns.fadeIn();
            $updateDetailsDropdown.find('h1').text('Edit Staff User');

            $.each($inputs, function(index, item){
                let $this = $(this),
                    $inputWrapper = $this.parent();

                    $this.attr("readonly", false);
                    $inputWrapper.removeClass('readonly');
            });

            $.each($dropdowns, function(index, item){

                $(this).attr("disabled", false);
            });

        });

        $('.js-save-update-account-ssu').on('click', function (e) {
                
            _isInvalid = [];

            $.each($inputs, function(index, item){
                let $this = $(this);

                if( isFieldEmpty($this) && $this.attr('required')) {

                    $this.parent().addClass('incomplete');
                    $this.siblings('.error').slideDown({
                        duration: 500,
                        easing: 'easeOutExpo',
                        queue: false
                    });

                    _isInvalid.push(0);
                }
            });

            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {

                _isInvalid = [];

                $(this).removeClass('error');

                loader.fadeIn();

                dataParams = {
                    "StaffId": isFieldEmpty($abbottAdminId) == true ? null : $abbottAdminId.val(),
                    "Details":{
                        "FirstName": isFieldEmpty($firstName) == true ? null : $firstName.val(),
                        "LastName": isFieldEmpty($lastName) == true ? null : $lastName.val(),
                        "InstitutionId": isFieldEmpty($company) == true ? null : $company.val(),
                        "MobileNumber": isFieldEmpty($primaryNumber) == true ? null : $primaryNumber.val(),
                        "EmailAddress": isFieldEmpty($email) == true ? null : $email.val()
                    }
                };

                $.ajax({
                    url: '/api/staffshop/update',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'PUT',
                    headers: { __RequestVerificationToken: updateDetailsDropdown.find('input[name=__RequestVerificationToken]').val() },
                    data: JSON.stringify(dataParams),
                    success: function (data) {
                        toaster('Account details has been saved!');
                        window.location.href = data.href;
                        loader.fadeOut();

                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });

                        $('.js-collapse-form-modal').trigger('click');
                    },
                    error: function (error) {

                        loader.fadeOut();
                        displayErrors(error, $errorContainer );
                    }
                });
            }
        });

        // Deactivate Admin Dropdown
        $('.js-deactivate-account-ssu').on('click', function (e){
            e.preventDefault();

            let isMobileDevice = Modernizr.mq('(max-width: 767px)');

            $.fancybox.open('#deactivate-admin', {
                autoSize: false,
                closeBtn: false,
                fitToView: false,
                height: isMobileDevice == true ? 300 : 200,
                width: isMobileDevice == true ? 250 : 500,
                padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
                type: 'inline',
                wrapCSS: 'modal'
            });
        });

        $('.js-agree-deactivate-ssu').on('click', function (e){
            $.fancybox.close();

            dataParams = {"EmailId": isFieldEmpty($email) == true ? null : $email.val()};

            $.ajax({
                url: '/api/abbotadmins/deactivate',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                type: 'PUT',
                headers: { __RequestVerificationToken: $updateDetailsDropdown.find('input[name=__RequestVerificationToken]').val() },
                data:JSON.stringify(dataParams),
                success: function (data) {
                    toaster('Account details has been saved!');
                    window.location.href = data.href;
                    loader.fadeOut();

                    $errorContainer.slideUp({
                        duration: 500,
                        easing: 'easeInOutExpo',
                        queue: false
                    });
                },
                error: function (error) {
                    loader.fadeOut();
                    displayErrors(error, $errorContainer );
                }
            });

        });

    }

    populateOverlay(json, id) {

        //reset previous dropdown if it was open and set as edit view
        $updateDetailsDropdown.find('h1').text('Edit Account');

        //$('.js-update-account').parent().show();
        //$updateDetailsBtns.hide();

        // $.each($inputs, function(index, item){
        //     let $this = $(this),
        //         $inputWrapper = $this.parent();

        //         $this.attr('readonly', true);
        //         $this.siblings('.error').hide();
        //         $inputWrapper.addClass('readonly');
        // });

        // $.each($dropdowns, function(index, item){
        //     let $this = $(this);

        //     $this.attr("disabled", true);
        //     $this.siblings('.error').hide();
        // });

        if(id!=null)
        {
            $abbottAdminId.val(id);
        }

        if(json.CanDeactivate != null && json.CanDeactivate === false)
        {
            $('.js-deactivate-account').hide();
        }

        if (json.FirstName != null) {
            $firstName
                .val(json.FirstName)
                .parent()
                .addClass('complete focus');
        }

        if (json.LastName != null) {
            $lastName
                .val(json.LastName)
                .parent()
                .addClass('complete focus');
        }

        if (json.CompanyName != null) {
            $company
                .val(json.CompanyName)
                .parent()
                .addClass('complete focus');
        }

        if (json.MobileNumber != null) {
            $primaryNumber
                .val(json.MobileNumber)
                .parent()
                .addClass('complete focus');
        }

        if (json.EmailAddress != null) {
            $email
                .val(json.EmailAddress)
                .parent()
                .addClass('complete focus');
        }
    }
}
